import api from './api';

export function postInternationalOperations(data) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/save-international-operations`, data);
}

export function postInternationalOperationsExposedPerson(data) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/create-pep`, data);
}
